module.exports = __webpack_public_path__ + "static/media/3.5bacd1e1.JPG";